<script lang="ts" setup>
import { CardProps } from "~/components/Banner/WhoWeAre/Utils/Card.props"
import { iconsSrcMap } from "~/components/Banner/WhoWeAre/Utils/Card.iconMapping"

withDefaults(defineProps<CardProps>(), {
  iconType: "shield"
})
</script>

<template>
  <div class="card flex w-fit flex-col items-center gap-y-2">
    <div v-if="!!iconType" class="card-icon">
      <UtilsIcon v-bind="iconsSrcMap[iconType]" />
    </div>
    <p v-if="!!title" class="pig-bold md:dolphin-bold">{{ title }}</p>
    <UtilsMarkdown
      v-if="!!text"
      class="beaver text-center md:text-left"
      :content="text"
    />
  </div>
</template>
